// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableContainer as MaterialUITableContainer,
    TableContainerProps as MaterialUITableContainerProps
} from '@material-ui/core'

interface TableContainerBaseProps { }
export type TableContainerProps = Partial<MaterialUITableContainerProps> & TableContainerBaseProps

export const TableContainer: FC<TableContainerProps> = ({ ...props }) => {
    return <MaterialUITableContainer {...props}></MaterialUITableContainer>
}
